import React, { type FC } from 'react';

import Box from '@amzn/meridian/box';
import Link from '@amzn/meridian/link';
import Text from '@amzn/meridian/text';

import EmDash from './emdash';

interface AssociateProfileEmployeeInfoProps {
  label: string;
  value?: string | number;
  url?: string;
}

const AssociateProfileEmployeeInfo: FC<AssociateProfileEmployeeInfoProps> = ({ label, value, url }) => (
  <Box>
    <Text color="secondary">{label}</Text>
    {value && url ? (
      <Link type="secondary" href={url} target="_blank" rel="noopener noreferrer">
        {value}
      </Link>
    ) : (
      <Text>{value || <EmDash />}</Text>
    )}
  </Box>
);

export default AssociateProfileEmployeeInfo;
